import { NgModule } from '@angular/core';
import { ColorPickerModule } from './components/color-picker/color-picker.module';
import { InputIntegerModule } from './components/input-integer/input-integer.module';
import { NumberplateInputModule } from './components/numberplate-input/numberplate-input.module';
import { SelectionDialogModule } from './components/selection-dialog/selection-dialog.module';
import { TableColumnEditorModule } from './components/table-column-editor/table-column-editor.module';
import { TableSelectionDialogModule } from './components/table-selection-dialog/table-selection-dialog.module';
import { ActionTabletRegistryService, TMCTableModule } from '@sdbn/appclient';
import { InstructionTestFailedController } from './controller/instruction-test-failed.controller';
import { InstructionTestController } from './controller/instruction-test.controller';
import { LanguageSelectionController } from './controller/language-selection.controller';
import { ProcessSelectionController } from './controller/process-selection.controller';
import { ScanBarcodeController } from './controller/scan-barcode.controller';
import { TerminalConfigurationController } from './controller/terminal-configuration.controller';
import { TextWidgetController } from './controller/text-widget.controller';
import { TmcLegacyValidatorModule } from './validators/tmc-legacy-validator.module';
import { NumberPlateScansComponent } from './widgets/numberplate-scans/component/numberplate-scans.component';
import { NumberplateScansModule } from './widgets/numberplate-scans/numberplate-scans.module';
import { ImageViewEditorComponent } from './widgets/terminal/image-view/component/image-view-editor/image-view-editor.component';
import { ImageViewComponent } from './widgets/terminal/image-view/component/image-view/image-view.component';
import { ImageViewModule } from './widgets/terminal/image-view/image-view.module';
import { LanguageSelectionComponent } from './widgets/terminal/language-selection/component/language-selection.component';
import { LanguageSelectionModule } from './widgets/terminal/language-selection/language-selection.module';
import { ProcessSelectionComponent } from './widgets/terminal/process-selection/component/process-selection.component';
import { ProcessSelectionModule } from './widgets/terminal/process-selection/process-selection.module';
import { ScanBarcodeComponent } from './widgets/terminal/scan-barcode/component/scan-barcode.component';
import { ScanBarcodeModule } from './widgets/terminal/scan-barcode/scan-barcode.module';
import { ShowMessageComponent } from './widgets/terminal/show-message/component/show-message.component';
import { ShowMessageModule } from './widgets/terminal/show-message/show-message.module';
import { TextWidgetComponent } from './widgets/terminal/text-widget/component/text-widget/text-widget.component';
import { TextWidgetModule } from './widgets/terminal/text-widget/text-widget.module';
import { RegistrationWithCodeQRCodeCombinedComponent } from './widgets/terminal/registration-with-code-qrcode-combined/component/registration-with-code-qrcode-combined.component';
import { RegistrationWithCodeQRCodeCombinedModule } from './widgets/terminal/registration-with-code-qrcode-combined/registration-with-code-qrcode-combined.module';
import { DictionaryLookupSelectionController } from './controller/dictionary-lookup-selection.controller';
import { TileSelectionModule } from './widgets/terminal/tile-selection/tile-selection.module';
import { TileSelectionComponent } from './widgets/terminal/tile-selection/component/tile-selection.component';
import { ServiceResponseModule } from '@sdbn/appclient';
import { EquipmentLogModule } from './common/components/equipment-log/equipment-log.module';
import { BlacklistAdministrationModule } from './widgets/blacklist-administration/blacklist-administration.module';
import { BlacklistAdministrationComponent } from './widgets/blacklist-administration/component/blacklist-administration.component';
import { ActionTabletLprFailuresComponent } from './components/action-tablet-lpr-failures/action-tablet-lpr-failures.component';
import { ActionTabletLPRFailuresModule } from './components/action-tablet-lpr-failures/action-tablet-lpr-failures.module';
import { ActionTabletLprItemModule } from './components/action-tablet-lpr/action-tablet-lpr.module';
import { ActionTabletBarrierControlModule } from './components/action-tablet-hardware-event/action-tablet-hardware-event.module';
import { AreaGateLogAdministrationWidgetModule } from './widgets/area-gate-log-administration/area-gate-log-administration.module';


export const MODULES = [
];

export const WIDGET_DEFINITION = [
  { key: 'languageSelectionWidget', name: 'Sprachauswahl', description: 'TBD', icon: 'fa-light fa-display-arrow-down', groupIdentifier: 'terminal', widgetComponent: LanguageSelectionComponent, editorComponent: null, autoreload: false },
  { key: 'processSelectionWidget', name: 'Auswahl Anmeldeprozess', description: 'TBD', icon: 'fa-light fa-display-arrow-down', groupIdentifier: 'terminal', widgetComponent: ProcessSelectionComponent, editorComponent: null, autoreload: false },
  { key: 'tileSelectionWidget', name: 'Tile Auswahl', description: 'TBD', icon: 'fa-light fa-display-arrow-down', groupIdentifier: 'terminal', widgetComponent: TileSelectionComponent , editorComponent: null, autoreload: false },
  { key: 'imageviewWidget', name: 'Image View', description: 'TBD', icon: 'fa-light fa-display-arrow-down', groupIdentifier: 'terminal', widgetComponent: ImageViewComponent, editorComponent: ImageViewEditorComponent, autoreload: false },
  { key: 'showMessageWidget', name: 'Show Message', description: 'TBD', icon: 'fa-light fa-display-arrow-down', groupIdentifier: 'terminal', widgetComponent: ShowMessageComponent, editorComponent: null, autoreload: false },
  { key: 'barcodeScanWidget', name: 'Barcode scan', description: 'TBD', icon: 'fa-light fa-qrcode', groupIdentifier: 'terminal', widgetComponent: ScanBarcodeComponent, editorComponent: null, autoreload: false },
  { key: 'registrationWithCodeQRCodeCombinedWidget', name: 'Anmeldung mit Code', description: 'TBD', icon: 'fa-light fa-display-arrow-down', groupIdentifier: 'terminal', widgetComponent: RegistrationWithCodeQRCodeCombinedComponent, editorComponent: null, autoreload: false },
  { key: 'textWidget', name: 'Text', description: 'TBD', icon: 'fa-light fa-qrcode', groupIdentifier: 'terminal', widgetComponent: TextWidgetComponent, editorComponent: null, autoreload: false },
  { key: 'numberplateScansWidget', name: 'Kennzeichen Scans', description: 'TBD', icon: 'fa-light fa-qrcode', groupIdentifier: 'displays', widgetComponent: NumberPlateScansComponent, editorComponent: null, autoreload: true },
  { key: 'blacklistAdminWidget', name: 'Blacklist Admin', description: 'TBD', icon: 'fa-light fa-ban', groupIdentifier: 'administration', widgetComponent: BlacklistAdministrationComponent, editorComponent: null },
];
export const WIZARD_STEP_CONTROLLER = [
  { key: 'terminal-configuration-controller', controller: TerminalConfigurationController },
  { key: 'instruction-test-controller', controller: InstructionTestController },
  { key: 'instruction-test-failed-controller', controller: InstructionTestFailedController},
  { key: 'language-selection-controller', controller: LanguageSelectionController },
  { key: 'process-selection-controller', controller: ProcessSelectionController },
  { key: 'scan-barcode-controller', controller: ScanBarcodeController },
  { key: 'text-view-controller', controller: TextWidgetController },
  { key: 'dictionary-lookup-selection-controller', controller: DictionaryLookupSelectionController }
];
export const WIZARD_DEFINITION = [];

@NgModule({
  declarations: [
  ],
  imports: [
    TileSelectionModule,
    ActionTabletBarrierControlModule,
    AreaGateLogAdministrationWidgetModule
  ],
  exports: [
    LanguageSelectionModule,
    ImageViewModule,
    ProcessSelectionModule,
    ScanBarcodeModule,
    RegistrationWithCodeQRCodeCombinedModule,
    ShowMessageModule,
    InputIntegerModule,
    NumberplateInputModule,
    ColorPickerModule,
    TMCTableModule,
    TableSelectionDialogModule,
    TableColumnEditorModule,
    ServiceResponseModule,
    SelectionDialogModule,
    TmcLegacyValidatorModule,
    TextWidgetModule,
    NumberplateScansModule,
    EquipmentLogModule,
    BlacklistAdministrationModule,
    ActionTabletLPRFailuresModule,
    ActionTabletLprItemModule
  ]
})
export class TmcCommonModule {

}
